import { Tile, ResourceLoader, MainLoader, Divider, T3 } from 'ia-react-core';
import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { MyProductsResourceInfo } from '../MyProductsResource/MyProductsResource';
import CrossSelling from './CrossSelling';
import List from './List';

export interface MyProductsTileProps {
  children?: ReactNode;
 }

const MyProductsTile: FC<MyProductsTileProps> = ({ children }) => {
  const { t } = useTranslation('MyProductsTile');
  return (
    <Tile data-testid="productsBox" isDivided={false}>
      {children}
      <T3>{t('title')}</T3>
      <Divider />
      <ResourceLoader
        resourceSrc={MyProductsResourceInfo.name}
        inlineErrorMessage={false}
        buttonAlign="left"
        CustomNoDataMessage={List}
        CustomLoader={MainLoader}
      >
        <List />
        <CrossSelling />
      </ResourceLoader>
    </Tile>
  );
};
export default MyProductsTile;
